import { Box, Button, HStack, Text, Textarea, VStack } from "@chakra-ui/react"
import type { RefObject } from "react"

function chakraRef<T extends HTMLElement>(r: RefObject<T | null>): RefObject<T> {
  return r as RefObject<T>
}

export type EmbedComposerProps = {
  embedComposerRef: RefObject<HTMLDivElement | null>
  embedTextareaRef: RefObject<HTMLTextAreaElement | null>
  embedInputValue: string
  embedInputError: string | null
  onChangeValue: (value: string) => void
  onClearError: () => void
  onSubmit: () => void
  onCancel: () => void
}

export function EmbedComposer({
  embedComposerRef,
  embedTextareaRef,
  embedInputValue,
  embedInputError,
  onChangeValue,
  onClearError,
  onSubmit,
  onCancel
}: EmbedComposerProps) {
  return (
    <Box px="4" pb="2">
      <VStack
        ref={chakraRef(embedComposerRef)}
        align="stretch"
        gap="2"
        bg="bg.muted"
        borderWidth="1px"
        borderColor="border"
        borderRadius="md"
        p="3"
      >
        <Text fontSize="xs" color="fg.muted">
          Paste an iframe embed code or URL
        </Text>
        <Textarea
          ref={chakraRef(embedTextareaRef)}
          size="sm"
          resize="vertical"
          minH="100px"
          placeholder="Paste code or URL here"
          value={embedInputValue}
          onChange={(event) => {
            onChangeValue(event.target.value)
            onClearError()
          }}
          onKeyDown={(event) => {
            if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
              event.preventDefault()
              onSubmit()
              return
            }
            if (event.key === "Escape") {
              event.preventDefault()
              onCancel()
            }
          }}
        />
        {embedInputError ? (
          <Text fontSize="xs" color="fg.error">
            {embedInputError}
          </Text>
        ) : null}
        <HStack justify="flex-end">
          <Button size="xs" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            size="xs"
            colorPalette="brand"
            disabled={!embedInputValue.trim()}
            onClick={onSubmit}
          >
            Insert Embed
          </Button>
        </HStack>
      </VStack>
    </Box>
  )
}
